// extracted by mini-css-extract-plugin
export default {"common":"\"../../styles/common.css\"","flex_middle":"common_flex_middle__Fngdy","icons":"styles_icons__bZIhv common_flex_middle__Fngdy","icon":"styles_icon__vKB8J"};